import {
	Select as StyledSelect,
	type SelectProps as StyledSelectProps,
} from 'components/FormUi';

import { useValidatedController } from './hooks';

interface Props extends StyledSelectProps {
	className?: string;
	name: string;
	requiredErrorMessage?: string;
}

export default function Select({
	className,
	defaultValue,
	disabled,
	name,
	required,
	requiredErrorMessage,
	...rest
}: Props) {
	const { errorMessage, invalid, onBlur, onChange, valid, value } =
		useValidatedController({
			name,
			defaultValue,
			requiredErrorMessage,
			required,
			disabled,
		});

	return (
		<StyledSelect
			onChange={onChange}
			onBlur={onBlur}
			value={value}
			invalid={invalid}
			valid={valid}
			errorMessage={errorMessage}
			className={className}
			required={required}
			disabled={disabled}
			{...rest}
		/>
	);
}
Select.displayName = 'ReactHookForm_Select';
